import DefaultComponent from '../../components/defaultComponent/DefaultComponent';
import SiteNavigation from '../../components/siteNavigation/SiteNavigation';
import Footer from '../../components/footer/Footer';
import OurJourneyTimelines from '../../components/ourJourneyTimelines/OurJourneyTimelines';
import HeroComponent from '../../components/HeroComponent/HeroComponent';
import FaqGroups from '../../components/FaqGroups/FaqGroups';
import NewsTimelines from '../../components/NewsTimelines/NewsTimelines';
import RichTextComponent from '../../components/AboutAmway/RichTextComponent/RichTextComponent';
import QuickLinkDesignOne from '../../components/AboutAmway/QuickLinkDesignOne/QuickLinkDesignOne';
import QuickLinkDesignTwo from '../../components/AboutAmway/QuickLinkDesignTwo/QuickLinkDesignTwo';
import HeroBanner from '../../components/heroBanner/HeroBanner';
import AwardsAndAccoladesTimelines from '../../components/AwardsAndAccoladesTimelines/AwardsAndAccoladesTimelines';
import AboutAmwayBrands from '../../components/AboutAmwayBrands/AboutAmwayBrands';
import AmwayBusinessLinks from '../../components/AmwayBusinessLinks/AmwayBusinessLinks';
import DownloadLink from '../../components/DownloadLink/DownloadLink';
import AmwayHighlights from '../../components/AmwayHighlights/AmwayHighlights';
import StepsToBusinessOwner from '../../components/StepsToBusinessOwner/StepsToBusinessOwner';
import BannerRichText from '../../components/BannerRichText/BannerRichText';
import OurPromises from '../../components/OurPromises/OurPromises';
import MeetOurPeople from '../../components/MeetOurPeople/MeetOurPeople';
import ShopByCategory from '../../components/ShopByCategory/ShopByCategory';
import Notification from '../../components/Notification/Notification';
import ShopByContainer from '../../components/ShopByContainer/ShopByContainer';
import FeaturedCardContainer from '../../components/FeaturedCardContainer/FeaturedCardContainer';
import VideoBanner from '../../components/VideoBanner/VideoBanner';
import FeaturedArticleCarousalComponent from '../../components/FeaturedArticleCarousalComponent/FeaturedArticleCarousalComponent';
import MyAccountContainer from '../../components/MyAccountContainer/MyAccountContainer';
import FeaturedCard from '../../components/FeaturedCardContainer/FeaturedCard';
import ContentCard from '../../components/ContentCard/ContentCard';
import ContentCardCarousel from '../../components/ContentCardCarousel/ContentCardCarousel';
import ArticleCard from '../../components/ArticleCard/ArticleCard';
import ResourceCard from '../../components/ResourceCard/ResourceCard';
import PromotionCard from '../../components/PromotionCard/PromotionCard';
import ArticleOverview from '../../components/ArticleOverview/ArticleOverview';
import Faq from '../../components/Faq/Faq';
import VideoSection from '../../components/VideoSection/VideoSection';
import HighlightsC from '../../components/HighlightsC/HighlightsC';
import StandardBannerNoCTA from '../../components/StandardBannerNoCTA/StandardBannerNoCTA';
import ImageWithOptionalCTA from '../../components/ImageWithOptionalCTA/ImageWithOptionalCTA';
import AudioPlayerContainer from '../../components/AudioPlayer/AudioPlayer';
import TextOnly from '../../components/TextOnly/TextOnly';
import ImageAndTextContainer from '../../components/ImageAndTextContainer/ImageAndTextContainer';
import GridViewGalleryContainer from '../../components/GridViewImageGallery/GridViewImageGallery';
import AccordionComponent from '../../components/AccordionComponent/AccordionComponent';
import TableComponent from '../../components/TableComponent/TableComponent';
import { ComponentRegistry, ComponentType } from './types/propTypes';

const componentRegistry: ComponentRegistry = {
  [ComponentType.table_component]: TableComponent,
  [ComponentType.accordion_component]: AccordionComponent,
  [ComponentType.image_and_text]: ImageAndTextContainer,
  [ComponentType.grid_view_image_gallery]: GridViewGalleryContainer,
  [ComponentType.audio_player]: AudioPlayerContainer,
  [ComponentType.text_only]: TextOnly,
  [ComponentType.image_with_optional_cta]: ImageWithOptionalCTA,
  [ComponentType.top_navigation]: SiteNavigation,
  [ComponentType.default]: DefaultComponent,
  [ComponentType.footer]: Footer,
  [ComponentType.journey_timelines]: OurJourneyTimelines,
  [ComponentType.hero_component]: HeroComponent,
  [ComponentType.faq_groups]: FaqGroups,
  [ComponentType.faq]: Faq,
  [ComponentType.news_timelines]: NewsTimelines,
  [ComponentType.rich_text_component]: RichTextComponent,
  [ComponentType.quick_links_design_one]: QuickLinkDesignOne,
  [ComponentType.quick_links_design_two]: QuickLinkDesignTwo,
  [ComponentType.hero_banner]: HeroBanner,
  [ComponentType.awards_timelines]: AwardsAndAccoladesTimelines,
  [ComponentType.about_amway_brands]: AboutAmwayBrands,
  [ComponentType.amway_highlights]: AmwayHighlights,
  [ComponentType.steps_to_business_owner]: StepsToBusinessOwner,
  [ComponentType.download_links]: DownloadLink,
  [ComponentType.amway_business_links]: AmwayBusinessLinks,
  [ComponentType.banner_rich_text_component]: BannerRichText,
  [ComponentType.amway_promises]: OurPromises,
  [ComponentType.meet_our_scientists]: MeetOurPeople,
  [ComponentType.featured_cards]: ShopByCategory,
  [ComponentType.notification]: Notification,
  [ComponentType.shop_by_container]: ShopByContainer,
  [ComponentType.featured_card_container]: FeaturedCardContainer,
  [ComponentType.video_banner]: VideoBanner,
  [ComponentType.featured_articles_carousal]: FeaturedArticleCarousalComponent,
  [ComponentType.my_account_container]: MyAccountContainer,
  [ComponentType.featured_display_card]: FeaturedCard,
  [ComponentType.content_card]: ContentCard,
  [ComponentType.content_card_carousal]: ContentCardCarousel,
  [ComponentType.article_card]: ArticleCard,
  [ComponentType.promotion_card]: PromotionCard,
  [ComponentType.resource_card]: ResourceCard,
  [ComponentType.article_carousel]: ContentCardCarousel,
  [ComponentType.promotion_carousel]: ContentCardCarousel,
  [ComponentType.resource_carousel]: ContentCardCarousel,
  [ComponentType.article_overview]: ArticleOverview,
  [ComponentType.video_section]: VideoSection,
  [ComponentType.highlights_c]: HighlightsC,
  [ComponentType.standard_banner_no_cta]: StandardBannerNoCTA,
};

export default componentRegistry;
